const data = {
    role: {},
    dept: {},
    user: {},
};
export default data;